import { render, staticRenderFns } from "./TopSpendingUsers.vue?vue&type=template&id=dd6233c8&"
import script from "./TopSpendingUsers.vue?vue&type=script&lang=js&"
export * from "./TopSpendingUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports